import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loader } from '../../../../../common/elements';
import webinarsActions from '../../../../../../actions/training/webinars/webinars';
import { ModuleVideo, NextModulesSlider } from './elements';

class WebinarItemFull extends Component {

    componentDidMount() {
        const { getCurrentWebinarModules, params, getCurrentWebinar } = this.props;
        getCurrentWebinar(params.webinarId);
        getCurrentWebinarModules(params.webinarId, params.seriesId);
    };

    componentWillReceiveProps(nextProps) {
        const { webinar, params } = this.props;
        if (webinar !== nextProps.webinar) {
            const hasAccess = nextProps.webinar.series.filter((series) => { return series.id === parseInt(params.seriesId, 10) && series.has_access === 1 })[0];
            if (hasAccess === undefined) {
                history.push(`/training/interactive-webinars`);
            }
        }
    }

    render() {

        const { modules, params } = this.props;

        if (!modules) {
            return <Loader />;
        }

        const module = modules
            .filter(module => parseInt(module.id, 10) === parseInt(params.moduleId, 10))[0];

        if (!module) {
            return <Loader />;
        }

        const nextModules = modules
            .filter(module => module.id > params.moduleId);

        return (
            <article className="container webinar-module-view-body">
                <ModuleVideo module={module} />
                {nextModules.length > 0 ? <NextModulesSlider nextModules={nextModules} params={params} /> : null}
            </article>
        );

    }
}

const mapStateToProps = (state) => {

    return {
        webinar: state.webinars.current_webinar,
        modules: state.webinars.current_webinar_modules,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCurrentWebinar: (webinarId) => dispatch(webinarsActions.getCurrentWebinar(webinarId)),
        getCurrentWebinarModules: (webinarId, seriesId) => dispatch(webinarsActions.getCurrentWebinarModules(webinarId, seriesId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebinarItemFull);



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/WebinarModuleView.js